import * as React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";
import TitleWithText from "../TitleWithText/TitleWithText";
import DownloadLimit from "./DownloadLimit";

class DownloadLimitExceededPopup extends React.Component {
  render() {
    return (
        <Dialog open={this.props.open} onClose={this.props.onClose}>
          <DialogContent>
            <DialogContentText>
              <TitleWithText title={"Daily Download Limit Exceeded"}>
                <DownloadLimit style={{marginTop: "2em"}} action={this.props.action} mediaType={this.props.mediaType}/>
              </TitleWithText>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.props.onClose}>Close</Button>
          </DialogActions>
        </Dialog>
    );
  }

}

export default DownloadLimitExceededPopup;
